//@ts-ignore
import React from 'react';
import { Portal } from 'react-portal';
import { TAudioSubtitlesProps } from './types';
import { SubtitleWrap } from './styled';

export const AudioSubtitle = ({ caption, isShown, settings }: TAudioSubtitlesProps) => {
  if (!isShown) return null;

  return (
    <Portal node={document && document.getElementById('page-root')}>
      <SubtitleWrap style={{ bottom: settings?.gutterBottom || '30px' }}>
        {caption && (
          <div
            className="subtitles-text"
            style={{
              fontFamily: settings?.fontFamily || 'Heebo, sans-serif',
              color: settings?.color,
              fontSize: settings?.fontSize + 'px',
            }}
          >
            {caption}

            <div
              className="subtitles-bg"
              style={{
                opacity: (settings?.opacity || 100) / 100,
                backgroundColor: settings?.backgroundColor,
              }}
            />
          </div>
        )}
      </SubtitleWrap>
    </Portal>
  );
};
